module.exports = __webpack_public_path__ + "static/media/modal-background.4db6f714.svg";